import {Injectable} from '@angular/core';
import {NzDrawerService} from 'ng-zorro-antd/drawer';
import {ModalOptions, NzModalRef, NzModalService} from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root'
})
export class ViewerService {
  duration = 7000;

  constructor(private drawer: NzDrawerService, private modal: NzModalService) {
  }

  createDrawer(component: any, data: any, metadata?: any) {
    return this.drawer.create<typeof component, { data: any }, string>({
      nzContent: component,
      nzContentParams: {
        ...data
      },
      ...metadata
    });
  }

  createModal(component: any, data: any, metadata?: ModalOptions): NzModalRef {
    return this.modal.create<typeof component, any>({
      nzContent: component,
      nzComponentParams: {
        ...data
      },
      ...metadata
    });
  }
}
